import { StepProps, TitleAndDescriptionProps, StepWizardProps } from '../../common/BaseStep';

export enum SignUpFields {
  Name = 'name',
  Email = 'email',
  Phone = 'phone',
}

export enum ErrorCode {
  Exists = 'Account already exists',
  InternalServerError = 'Error',
}

export interface SignUpValues {
  [SignUpFields.Name]: string;
  [SignUpFields.Phone]: string;
  [SignUpFields.Email]: string;
}

export interface ServerError {
  message: string;
  errorCode: ErrorCode;
}

export interface InputFieldProps {
  type: SignUpFields;
  label: string;
  placeHolder: string;
  explanation?: string;
}

export interface SignUpStepProps extends TitleAndDescriptionProps, StepProps, StepWizardProps {
  inputFields: InputFieldProps[];
  doNotFindGroupsOptions?: boolean;
  showPaymentSummary?: boolean;
}
